export interface DateFieldOption {
  id: string;
  name: string;
}

export const DATE_FIELD_OPTIONS: DateFieldOption[] = [
  { id: 'lastActiveTo', name: 'Last Active' },
  { id: 'createdTime', name: 'Created On' },
  { id: 'lastSystemUpdate', name: 'Last System Update' },
  { id: 'lastUserUpdate', name: 'Last User Update' },
  { id: 'confirmedTime', name:"Confirmed Time"}
];